import i18n from '@/utils/i18n';
import React from 'react';
import { Icons, List, Skeleton, YStack } from '@usepepper/sprout-kit-ui';

const ROW_HEIGHT = 52;
const LABEL_WIDTH = 148;

export const OrderEntryMobileHeaderPanelSkeleton: React.FC = () => (
  <YStack
    accessibilityLabel={i18n.t(
      'sales_portal.order_entry.mobile_header.a11y.loading',
    )}
    accessibilityState={{ busy: true }}
  >
    <List>
      <List.Separator borderColor="$borderPrimary" />

      <List.Item
        alignItems="center"
        height={ROW_HEIGHT}
        paddingHorizontal="$0"
        paddingVertical="$0"
      >
        <List.Item.Leading marginRight="$10">
          {<Icons.Calendar color="$iconPrimary" size={24} />}
        </List.Item.Leading>
        <List.Item.Content>
          <Skeleton height="$16" width={LABEL_WIDTH} />
        </List.Item.Content>
      </List.Item>

      <List.Separator borderColor="$borderPrimary" />

      <List.Item
        alignItems="center"
        height={ROW_HEIGHT}
        paddingHorizontal="$0"
        paddingVertical="$0"
      >
        <List.Item.Leading marginRight="$10">
          {<Icons.List color="$iconPrimary" size={24} />}
        </List.Item.Leading>
        <List.Item.Content>
          <Skeleton height="$16" width={LABEL_WIDTH} />
        </List.Item.Content>
      </List.Item>
    </List>
  </YStack>
);
